import { FC } from "react";
import { ThemeProvider } from "@mui/material/styles";
import { createTheme } from "@mui/material/styles";
import DynamicCard from "./default";
import { DynamicCardProps } from "./types";

// Nova Press theme configuration
const NovaTheme = {
  palette: {
    primary: {
      main: "#01a750",
      contrastText: "#fff",
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
};

const NovaPressDynamicCard: FC<DynamicCardProps> = (props) => {
  // Create theme instance for this component
  const theme = createTheme(NovaTheme);

  return (
    <ThemeProvider theme={theme}>
      <DynamicCard {...props} theme="nova-press" />
    </ThemeProvider>
  );
};

NovaPressDynamicCard.displayName = "NovaPressDynamicCard";

export default NovaPressDynamicCard;
